function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.875 1.57143H6.5V2.35714H8.125V0H0V2.35714H1.625V1.57143H3.25V9.42857H1.625V11H6.4992V9.42857H4.875V1.57143Z",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 3.92857V6.28571H8.125V5.5H8.9375V9.42857H8.125V11H11.375V9.42857H10.5625V5.5H11.375V6.28571H13V3.92857H6.5Z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/typography.05825195.svg";
export { SvgComponent as ReactComponent };